import React from 'react';
import ReactDOM from 'react-dom';
import window from 'window-or-global';

import { getSessionData, SessionDataContext } from '@confluence/session-data';

import ComponentWrapper from '../ComponentWrapper';
import configureStore from '../../../stores/configureStore';
import { subscribe } from '../../../subscriptions';

const store = configureStore({ isServerRenderedPage: true });
subscribe(store);

const context = {
	insertCss: (styles) => styles._insertCss(),
};

/**
 * Method for rendering React/Redux component
 * Usage:
 * import renderComponent from './renderComponentIntoDOM';
 * renderComponent(<YourComponent />, 'your-component-section-id');
 * OR renderComponent(<YourComponent />, DOMComponent);
 *
 * @param children
 * @param container DOM node or id string
 */
const renderComponentIntoDOM = (children, container, renderAsRoot = false) => {
	if (typeof container === 'string') {
		container = window.document.getElementById(container);
	}
	getSessionData().then((sessionData) => {
		// eslint-disable-next-line react/no-deprecated
		ReactDOM.render(
			<SessionDataContext.Provider value={sessionData}>
				<ComponentWrapper store={store} context={context} renderAsRoot={renderAsRoot}>
					{children}
				</ComponentWrapper>
			</SessionDataContext.Provider>,
			container,
		);
	});
};

export default renderComponentIntoDOM;
